import React from "react";
import { styled } from "styled-components";
import { Common } from "../../styles/Common";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    width?: string;
    value: any;
    onChange?: any;
    placeholder: string;
    type?: string;
    onBlur?: any;
    onKeyDown?: any;
    onKeyUp?: any;
    isDisabled?: boolean;
    readOnly?: boolean;
    inputRef?: any;
    inputmode?: "text" | "search" | "email" | "tel" | "url" | "none" | "numeric" | "decimal";
    autocomplete?: string;
    bgColor?: string;
    borderColor?: string;
    noBorder?: boolean;
    height?: string;
    as?: keyof JSX.IntrinsicElements;
    onFocus?: any;
    maxLength?: number;
    minLength?: number;
}

const MgInput: React.FC<Props> = ({
    width = "336px",
    noBorder,
    value,
    onChange,
    placeholder,
    type = "text",
    onBlur,
    onKeyDown,
    onKeyUp,
    isDisabled = false,
    readOnly = false,
    inputRef,
    inputmode,
    autocomplete,
    bgColor,
    borderColor,
    height,
    as,
    onFocus,
    maxLength,
    minLength,
}) => {
    return (
        <InputStyle
            as={as}
            $width={width}
            $bgColor={bgColor}
            $borderColor={borderColor}
            $noBorder={noBorder}
            $height={height}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            type={as ? undefined : type}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
            onKeyUp={onKeyUp}
            autoComplete={autocomplete ? autocomplete : type === "password" ? "off" : "on"}
            disabled={isDisabled}
            readOnly={readOnly}
            ref={inputRef}
            onFocus={onFocus}
            inputMode={inputmode}
            maxLength={maxLength}
            minLength={minLength}

        />
    );
};

export default MgInput;

const InputStyle = styled.input<{
    $width: string;
    $bgColor?: string;
    $borderColor?: string;
    $noBorder?: boolean;
    $height?: string;
}>`
    width: ${(props) => props.$width};
    max-width: 100%;
    padding: 14px;
    box-sizing: border-box;
    font-weight: 400;
    font-size: 15px;
    border: ${(p) => (p.$noBorder ? "none" : `1px solid ${p.$borderColor || Common.colors.grey04}`)};
    background: ${(p) => p.$bgColor || "white"};
    outline: none;
    border-radius: 8px;
    line-height: 140%;
    background: ${(props) => props.$bgColor || "white"};
    min-height: ${(p) => p.$height || "auto"};
    resize: ${(p) => (p.as === "textarea" ? "none" : "initial")};

    &:focus {
        border: 1px solid ${Common.colors.aucMarkerColor};
    }
    &::placeholder {
        color: ${Common.colors.grey04};
        font-weight: 400;
        font-size: 15px;
    }
    &:disabled {
        background: #f0f0f0;
    }

    @media screen and (max-width: 768px) {
        width: 100%;
    }

    .moneybox {
        margin-bottom: 8px;
    }
`;
